@if (variant() === 'tab') {
    <div
        [ngClass]="{ centered: alignment() === 'centered' }"
        [class]="containerClass()"
    >
        <ul
            class="nav tabs w-100"
            [ngClass]="[
                justifyContentClass(),
                tabs.length === 1 ? 'single' : '',
            ]"
            role="tablist"
            aria-label="Tab Navigation"
            [ngStyle]="{
                '--tab-padding-x': tabPaddingX(),
                '--tab-padding-y': tabPaddingY(),
                '--tab-border-width': tabBorderWidth(),
                '--transition-duration': transitionDuration(),
                '--transition-timing': transitionTiming(),
                '--active-color': activeColor(),
                '--inactive-color': inactiveColor(),
                '--hover-opacity': hoverOpacity(),
                '--centered-padding-x': centeredPaddingX(),
                '--single-tab-width': singleTabWidth(),
            }"
        >
            @for (tab of tabs; track tab.index) {
                <li
                    id="tab-{{ tab.index }}"
                    role="tab"
                    [attr.tabindex]="isSelected(tab) ? 0 : -1"
                    class="nav-item"
                    [class.active]="isSelected(tab)"
                    [class.disabled]="tab.disabled"
                    (click)="setSelected(tab)"
                    (keypress)="handleKeyPress($event, tab)"
                    [ngStyle]="{
                        flex: tabFlex(),
                        'text-align': tabTextAlign(),
                        opacity: tab.disabled ? disabledOpacity() : 1,
                        'pointer-events': tab.disabled ? 'none' : 'auto',
                        'padding-left':
                            alignment() === 'centered'
                                ? centeredPaddingX()
                                : null,
                        'padding-right':
                            alignment() === 'centered'
                                ? centeredPaddingX()
                                : null,
                        width: tabs.length === 1 ? singleTabWidth() : null,
                    }"
                >
                    <span
                        class="nav-link h-100"
                        [class.active-link]="isSelected(tab)"
                        [ngStyle]="{
                            padding:
                                'var(--tab-padding-y) var(--tab-padding-x)',
                            transition:
                                'border-bottom-color var(--transition-duration) var(--transition-timing), ' +
                                'color var(--transition-duration) var(--transition-timing)',
                            color: isSelected(tab)
                                ? 'var(--active-color)'
                                : 'var(--inactive-color)',
                            'border-bottom':
                                showUnderline() && isSelected(tab)
                                    ? 'var(--tab-border-width) solid ' +
                                      tabBorderColor()
                                    : 'var(--tab-border-width) solid transparent',
                        }"
                    >
                        <span class="font-tab">
                            {{ tab.label }}
                        </span>
                    </span>
                </li>
            }
        </ul>
    </div>
} @else {
    <div [class]="containerClass()">
        <ul class="nav tabs w-100" role="tablist" aria-label="Tab Navigation">
            @for (tab of tabs; track tab.index) {
                <li
                    id="tab-{{ tab.index }}"
                    role="tab"
                    class="nav-item pills"
                    [class.disabled]="tab.disabled"
                    [attr.tabindex]="isSelected(tab) ? 0 : -1"
                >
                    <telxl-button
                        colour="pill"
                        [active]="isSelected(tab)"
                        [disabled]="tab.disabled ?? false"
                        (buttonClick)="setSelected(tab)"
                    >
                        {{ tab.label }}
                    </telxl-button>
                </li>
            }
        </ul>
    </div>
}
